const TRANSLATION = {
  buyModal: {
    afterFree: 'Efter din gratis prøveperiode',
    btn: 'Prøv det gratis',
    freeTrial: '3-dages gratis prøveperiode',
    monthLabel: 'måned',
    selectLabel: 'Vælg en plan',
    title: 'Abonnementplan',
    yearLabel: 'år',
  },
  contact: {
    block1:
      'For tilpasninger, spørgsmål eller forslag, bedes du kontakte os på contact@noam.tools. Vi svarer hurtigt.',
    block2: 'Støt os ved at bedømme os på Google Apps Extension-butikken med ★★★★★.',
    block3: 'Hjælp andre ved at dele denne udvidelse:',
    title: 'Kontakt os',
  },
  help: {
    AquickOverviewOfNoam: 'En hurtig oversigt over Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Håndtering af favoritter',
    Fixedplugin: 'Fastlagt plugin',
    Focusing: 'Fokusering',
    Free: 'Gratis',
    FreeTrialBenefits: 'Fordele ved gratis prøveperiode',
    GoWithWikipedia: 'Brug Wikipedia',
    GoWithYouTube: 'Vælg YouTube',
    HoverTranslation: 'Svævende Oversættelse',
    Howtouse: 'Hvordan man bruger',
    ImageTranslation: 'Billedoversættelse',
    InstantTranslation: 'Instant oversettelse',
    Membership: 'Medlemskab',
    NoamHelp: 'Noam hjælper dig med at oversætte og opsummere',
    PDFparallelTranslation: 'PDF Parallel Oversættelse',
    ParallelTranslation: 'Parallelt Oversættelse',
    SkipAllSteps: 'Spring alle trin over',
    Summary: 'Opsummering',
    Translation: 'Oversættelse',
    TryItForFree: 'Prøv det gratis',
    Video: 'Video',
    VideoSummary: 'Videoresumé',
    VideoTranslation: 'Videotolkning',
    WebSummary: 'Webopsummering',
    WordSelectionTranslation: 'Ordvalgsoversættelse',
    benefits: 'Vi har fordele klar til dig!',
    dayFree: '3-dages gratis prøveperiode',
    done: 'Færdig',
    next: 'Næste',
    pin: 'Pin Noam for nemmere adgang～～',
    planIsNotExist: 'Planen er ikke tilgængelig',
    startWiki: 'Lad os starte med Wikimedia!',
    startYoutube: 'Lad os starte med YouTube!',
    try: 'Prøv det',
    tryNow: 'Prøv det nu!',
  },
  home: {
    PDFTranslate: {
      desc: 'Tveersproget oversættelse + Chat PDF',
      sub1: {
        desc: 'To双语 læsning lader dig sammenligne originalteksten og oversættelsen side om side, hvilket forbedrer læseeffektiviteten.',
        title: 'Tveersproget Læsning',
      },
      sub2: {
        desc: 'AI analyserer og opsummerer, og kan svare på dine spørgsmål baseret på PDF-indholdet.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-drevet PDF-oversættelse for større nøjagtighed og effektivitet.',
        title: 'Præcision og effektivitet',
      },
      title: 'PDF Oversæt',
    },
    aiAssistant: {
      desc: 'Gør weboversættelse smartere og mere bekvem',
      panel1: {
        desc: 'To-talsprogsovervejende oversættelser hjælper dig med at sammenligne originalteksten med oversættelsen, så du kan forstå bedre og forbedre din læseeffektivitet.',
        title: 'To sprogets oversættelse',
      },
      panel2: {
        left: {
          desc: 'Når du浏ser på en hjemmeside, hold markøren over indholdet du skal oversætte for at se oversættelsen.',
          title: 'Hover-oversættelse',
        },
        right: {
          desc: 'Når du浏览 en websted, markér den tekst, du ønsker at oversætte for at se oversættelsen.',
          title: 'Tekstmarkeringsoversættelse',
        },
      },
      panel3: {
        one: {
          desc: 'Oversæt og opsummer websteder og videindhold når som helst, hvor som helst, for en mere problemfri oplevelse!',
          title: 'Point and Click',
        },
        three: {
          desc: 'En AI-drevet stor sprogmodel sikrer oversættelsesnøjagtighed og konsistens for en forbedret læseoplevelse.',
          title: 'AI-drevet',
        },
        two: {
          desc: 'Flersproget fuld dækning, tosproget barrierefri læsning, énklik-oversættelse – oplev forskellen!',
          title: 'Mere omfattende og bekvem',
        },
      },
      panel4: {
        tab1: {
          desc: 'Din effektivitetsekspert - ved hjælp af ChatGPT oversætter og opsummerer Noam indhold fra YouTube-videoer for at spare dig tid!',
          key: 'Video',
          title: 'Videooversættelse & Opsummering',
        },
        tab2: {
          desc: 'Klik for at oversætte billeder, når du surfer på nettet.',
          key: 'Billede',
          title: 'Billedoversættelse',
        },
        tab3: {
          desc: 'Ekstraherer øjeblikkeligt nøgleinformation fra websteder og leverer en opsummering, hvilket forbedrer din læseeffektivitet.',
          key: 'Web',
          title: 'Weboversættelse & Opsummering',
        },
        tag1: 'Simpel',
        tag2: 'Effektiv',
        tag3: 'Nem at forstå',
      },
      title: 'AI-assistent',
    },
    getStart: 'Start',
    getStartedForFree: 'Start gratis',
    howItWork: {
      desc: 'Noam integrerer AI-modeller for at levere en intelligent oplevelse til brugere inden for tværsproget hjemmesideoversættelse og -opsummering, PDF- og billedoversættelse samt videooversættelse og -opsummering',
      title: 'Hvordan det virker',
    },
    lastBlock: { desc: 'Bedre AI- oversættelse for en mere jævn læseoplevelse' },
    top: {
      desc: 'Noam er en gratis AI-browserudvidelse, der hjælper dig med at oversætte og opsummere websteder, videoer og PDF-indhold.\n      Tilslut dig Noam og oplev magien!',
      title1: 'En Magi',
      title2: 'Én klik',
    },
    userReviews: {
      desc: 'Fem-stjerners anmeldelser på Chrome Web Store',
      title: 'Brugeranmeldelser',
    },
  },
  installTips: {
    btn: 'Prøv det nu',
    text: 'Installér "Noam Browser Plugin" for at låse op for flere funktioner! Webkrydshenvisning,\n    webvideosammendrag og meget mere!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amharisk',
    ar: 'arabisk',
    as: 'assamesisk',
    auto: 'Auto-detekter',
    az: 'azerbajdzjansk',
    ba: 'basjkir',
    bg: 'bulgarsk',
    bn: 'bengali',
    bo: 'tibetansk',
    bs: 'bosnisk',
    ca: 'katalansk',
    cs: 'tjekkisk',
    cy: 'walisisk',
    da: 'Dansk',
    de: 'tysk',
    dsb: 'Nedersorbisk',
    dv: 'divehi',
    el: 'græsk',
    en: 'Engelsk',
    es: 'spansk',
    et: 'estisk',
    eu: 'baskisk',
    fa: 'persisk',
    fi: 'finsk',
    fil: 'filipino',
    fj: 'fijiansk',
    fr: 'fransk',
    frCA: 'Fransk (Canada)',
    ga: 'irsk',
    gl: 'galicisk',
    gom: 'konkani',
    gu: 'gujarati',
    ha: 'Hausa',
    he: 'hebraisk',
    hi: 'hindi',
    hr: 'kroatisk',
    hsb: 'Oversorbisk',
    ht: 'haitisk kreolsk',
    hu: 'ungarsk',
    hy: 'armensk',
    id: 'indonesisk',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'islændsk',
    it: 'italiensk',
    iu: 'inuktitut',
    iuLatn: 'Inuktitut (latin)',
    ja: 'japansk',
    ka: 'georgisk',
    kk: 'kasakh',
    km: 'khmer',
    kmr: 'Kurdisk (nordisk)',
    kn: 'Kannada',
    ko: 'koreansk',
    ku: 'Kurdisk (central)',
    ky: 'kirgisisk',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'litauisk',
    lug: 'Ganda',
    lv: 'latvisk',
    lzh: 'Kinesisk (litterært)',
    mai: 'Maithili',
    mg: 'malagasi',
    mi: 'maori',
    mk: 'makedonsk',
    ml: 'malayalam',
    mnCyrl: 'mongolsk (kyrillisk)',
    mnMong: 'mongolsk (traditionel)',
    mr: 'marathi',
    ms: 'Malay',
    mt: 'maltesisk',
    mww: 'Hmong Daw',
    my: 'Myanmar (burmesisk)',
    nb: 'norsk',
    ne: 'nepalesisk',
    nl: 'hollandsk',
    noSearchLang: 'Sprog understøttes ikke',
    nso: 'Sesotho sa Leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'punjabi',
    pl: 'polsk',
    placeholder: 'Søg',
    prs: 'Dari',
    ps: 'pashto',
    pt: 'Portugisisk (Brasilien)',
    ptPT: 'Portugisisk (Portugal)',
    ro: 'rumænsk',
    ru: 'rus',
    run: 'rundi',
    rw: 'kinyarwanda',
    sd: 'Sindhi',
    si: 'singalesisk',
    sk: 'slovakisk',
    sl: 'slovensk',
    sm: 'samoisisk',
    sn: 'Shona',
    so: 'somalier',
    sq: 'albansk',
    srCyrl: 'serbisk (kyrillisk)',
    srLatn: 'Serbisk (latin)',
    st: 'sesotho',
    sv: 'svensk',
    sw: 'swahili',
    ta: 'tamil',
    te: 'Telugu',
    th: 'thai',
    ti: 'Tigrinja',
    tk: 'turkmener',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Setswana',
    to: 'tongansk',
    tr: 'tyrkisk',
    tt: 'Tatar',
    ty: 'tahitiansk',
    ug: 'Uyghur',
    uk: 'ukrainsk',
    ur: 'urdu',
    uz: 'Usbekisk (latin)',
    vi: 'vietnamesisk',
    xh: 'xhosa',
    yo: 'Yoruba',
    yua: 'yucatekmaya',
    yue: 'Kantonesisk (traditionel)',
    zh: 'kinesisk',
    zhHans: 'Kinesisk Forenklet',
    zhHant: 'Kinesisk traditionel',
    zu: 'Zulu',
  },
  login: {
    and: 'og',
    btn: 'Log ind med Google',
    btn1: 'Log ind nu',
    desc: 'Log ind for at låse op for flere oplevelser',
    policy: 'Persondatapolitik',
    terms: 'Brugsbetingelser',
    tips: 'Ved at tilmelde mig accepterer jeg',
    title: 'Velkommen til Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Følg', twitter: 'Twitter' },
    legal: { policy: 'Fortrolighedspolitik', terms: 'Vilkår for service', title: 'Juridisk' },
    product: {
      image: 'Billedoversættelse',
      pdf: 'PDF- oversættelse',
      title: 'Produkter',
      video: 'Videooversættelse & Opsummering',
      web: 'Weboversættelse & Opsummering',
    },
    resources: { title: 'Ressourcer' },
    tools: { title: 'Værktøjer', pdf: 'PDF- oversættelse' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Hjælp',
    logout: 'Log ud',
    logoutSucc: 'Logget ud.',
    pricing: 'Priser',
    settings: 'Indstillinger',
    signUp: 'Log ind',
  },
  pdf: {
    autoDetect: 'Auto-Detekter',
    cancelBtn: 'Annuller',
    cancelUpload: 'Annuller',
    chatPdf: {
      summaryError: 'Opsummering mislykkedes, prøv venligst igen senere',
      chatError: 'Chatten mislykkedes, prøv venligst igen senere',
      Search: 'Søg',
      cancel: 'Annuller',
      chatTitle: 'Velkommen til Noam! Her er en opsummering af din PDF:',
      clear: 'Klar',
      clearContent:
        'Dette vil starte en ny samtale. Den aktuelle samtale bliver ikke gemt. Er du sikker?',
      clearDialogTitle: 'Bekræft venligst',
      clearSucc: 'Renset',
      copy: 'Kopiér',
      copySucc: 'Kopieret',
      delete: 'Slet',
      deleteCancel: 'Annuller',
      deleteContent: 'Denne PDF kan ikke gendannes, når den er slettet. Er du sikker?',
      deleteOk: 'Slet',
      deleteSuccess: 'Slettet',
      deleteTitle: 'Bekræft sletning',
      expand: 'Kolaps',
      historyTitle: 'Historie',
      listError: 'Kunne ikke indlæse læselisten. Prøv igen senere eller kontakt support.',
      loading: 'Indlæser...',
      noDataDesc: 'Endnu ingen historie.',
      noMore: 'Ikke mere indhold.',
      placeholder: 'Stil spørgsmål om denne PDF',
      summaryTitle: 'Du er måske interesseret i disse spørgsmål:',
    },
    collectionEmpty: 'Din samling er tom.',
    collectionTab: 'Noter',
    dataLoading: 'Indlæser...',
    dialogContent: 'Er du sikker på, at du vil slette dette?',
    dialogTitle: 'Bekræft venligst',
    download: {
      both: 'tveersproget',
      btn: 'Gem',
      cancel:
        'Hvis du lukker dette vindue, annulleres downloaden af PDF-filen. Er du sikker på, at du vil annullere?',
      desc: 'Gem til enhed: Downloader oversættelser som billeder; Gem & Udskriv: Downloader oversættelser i originalformat med kopieringsunderstøttelse.',
      download: 'Download',
      downloadMsg1: 'PDF- oversættelsesfremskridt:',
      downloadMsg2: 'Forventet resterende tid:',
      downloadSucc: "PDF'en er klar! Klik for at gemme.",
      downloadTip: 'Downloader PDF. Luk ikke dette vindue for at undgå downloadfejl.',
      error: 'Kunne ikke gemme. Prøv i stedet at udskrive.',
      fileName: 'Filnavn:',
      fileType: 'Filtype:',
      loading: 'Gemmer...',
      loading2: 'Indlæser...',
      minute: 'Minutter...',
      msg1: 'Nogle oversættelser i dette dokument er længere end den oprindelige tekst og kan overlappe hinanden i den downloadede fil. Vi anbefaler at læse på hjemmesiden.',
      msg2: 'Oversættelsen er endnu ikke færdig. Download venligst, når oversættelsen er afsluttet.',
      msg3: '2. Nogle oversættelser er for lange. Læs på hjemmesiden for at undgå tekstoverlapp.',
      msg4: 'Oversættelsesopgaver er under udarbejdelse. Prøv venligst igen, når de er fuldførte.',
      progress:
        'Oversætter PDF. Fremgang: {{progress}}, Estimeret tid tilbage: {{minutes}} minutter...',
      save: 'Gem til enhed',
      savePrint: 'Gem & Udskriv',
      success: 'Downloadet',
      trans: 'Kun oversættelse',
      transContinue: 'Fortsæt med at oversætte',
    },
    downloadBtn: 'Download',
    dragTipModal: {
      black: 'rum',
      leftKey: 'venstre knap',
      ok: 'Forstået',
      press: 'Tryk',
      tips: 'at trække og se',
    },
    entry: "PDF'er",
    fileErrMsg: 'Filindlæsning mislykkedes. Prøv igen senere eller kontakt support.',
    fileMsg: 'Nuværende filstørrelse:',
    fileMsg2: 'Upload venligst en fil, der er mindre end 300MB.',
    freeBannerBtn: 'Opgradering',
    freeBannerTips: 'Gratis PDF- oversættelsesgrænse nået',
    guide: {
      placeholder: 'Indsæt PDF-linket her',
      start: 'Start oversættelse',
      text1: 'Tveersproget Læsning',
      text2:
        'Læs tosprogigt for at sammenligne originalteksten og oversættelsen side om side, hvilket forbedrer din effektivitet.',
      text3: 'Chat med din PDF',
      text4:
        'AI-drevet analyse og opsummering. Stil spørgsmål om din PDF og få øjeblikkelige svar.',
      text5: 'Præcis & Effektiv',
      text6: 'AI-drevet PDF- oversættelse til højere nøjagtighed og effektivitet.',
      title1: 'To sprogets oversættelse',
      title2: 'Chat med din PDF',
      toast: 'Indtast venligst en gyldig online PDF-link der slutter med .pdf',
    },
    hasTransTask: 'En oversættelsesopgave er i gang. Vent venligst.',
    hoverTrans: 'Paragrafer med svæv-og-oversæt',
    initial: 'Oversæt PDF',
    installText: 'Din én-stop-løsning til daglige oversættelser.',
    installText2: 'Installér først udvidelsen',
    installTips:
      'Installér udvidelsen for endnu flere PDF-øversættelser og mere jævne hjemmesideøversættelser:',
    kw: 'klammer',
    link: 'link',
    listError: "Kunne ikke indlæse PDF'er. Prøv venligst igen senere eller kontakt support.",
    memoTotalCount: 'i alt 1 stykke',
    new: 'nyt dokument',
    noId: 'Fil-ID blev ikke fundet.',
    notPdf: 'Kun PDF-filer.',
    okBtn: 'Slet',
    okBtn2: 'Forstået',
    original:
      'Du er en meget præcis og pålidelig AI designet til at generere JSON-output, der stemmer nøjagtigt overens med et angivet JSON-skema.\n\nDu skal følge disse regler:\n1. Overhold strengt JSON-skemaets struktur.\n2. Match alle datatyper, påkrævede felter og begrænsninger nøjagtigt.\n3. INCLUDE IKKE nogen ekstra tekst, forklaring, markdown eller kommentarer.\n4. Output UDELIGE JSON-objektet — ingen kodeblokke, ingen præambel, ingen indpakning.\n\nSkemaoplysningerne er angivet nedenfor.\n- Skema Navn: translate_result\n- JSON Skema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Parallel',
    parseErrDialogContent:
      "Denne PDF-link kan ikke oversættes direkte. Download venligst PDF'en og upload den til oversættelse.",
    parseErrTips: 'Kunne ikke analysere filen',
    parseFileToast: 'Kunne ikke fortolke filen. Prøv venligst igen senere eller kontakt supporten.',
    pdfLoading: 'Parsering...',
    searchPlaceholder: 'Søg',
    selectTrans: 'Vælg tekst at oversætte',
    shareBtn: 'Del',
    shareBtnText1: 'Generer delingslink',
    shareBtnText2: 'Opdater delt indhold',
    shareModal: {
      cancel: 'Annuller',
      copy: 'Kopiér',
      copySucc: 'Link kopieret',
      custom: 'Tilpas: ',
      errMsg: 'Det valgte indhold er endnu ikke fuldt oversat. Oversæt venligst før deling.',
      gen: 'Del',
      modify: 'Redigér',
      notSupport: 'Denne sprog understøttes i øjeblikket ikke.',
      page: 'Sider',
      pageNuErr: 'Indtast venligst et gyldigt sidesnummer.',
      range: 'Omfang:',
      remain: 'resterende',
      remain1: 'Samlet estimeret tid:',
      search: 'Søg',
      settings: 'Delindstillinger:',
      shareSetting: 'Delindstillinger',
      shareText: 'Del',
      shareTips: 'Del linket til den oversatte PDF med dine venner:',
      sourceLang: 'Fra:',
      target: 'Til:',
      text1: 'Delindstillinger',
      text2: 'Generer delingslink',
      totalPage: '1 side i alt',
      trans: 'Oversæt',
      translateTips:
        'Tip: Hvis oversættelsen tager lang tid, kan du lukke dette vindue og dele senere.',
      translating: 'Oversætter PDF...',
      update: 'Opdater delingslink',
    },
    shareMsg1: 'Del-link genereret.',
    shareMsg2: 'Delt indhold opdateret.',
    shareMsg3: 'Kunne ikke generere delingslink. Prøv igen senere eller kontakt support.',
    shareMsg4: 'Kunne ikke opdatere delt indhold. Prøv venligst igen senere eller kontakt support.',
    shareTips: 'Din PDF- oversættelse er klar! Del den med dine venner.',
    start: 'Start din gratis prøveperiode',
    thumbnail: 'Indholdsfortegnelse',
    toast1: 'Indlæser PDF. Prøv venligst igen senere.',
    toast2: 'PDF-indhold behandles. Dialog understøttes for tiden ikke.',
    toast3: 'Downloader. Prøv igen, når downloaden er færdig.',
    toolbar: { Adjust: 'Juster', autoFit: 'Auto-Tilpas' },
    trans: 'Oversættelse',
    transSucc: 'Oversættelse successfuld!',
    unLoginToast: 'Log ind for at bruge denne funktion.',
    uploadBtn: 'Upload',
    uploadErr: 'Filupload fejlede. Prøv venligst igen senere eller kontakt support.',
    uploadErrSignUrl:
      'Kunne ikke hente upload-URL. Prøv venligst igen senere eller kontakt support.',
    uploadMsg1: 'Træk og slip din fil her.',
    uploadMsg2: 'Understøttede filtyper: PDF  |  Maksimal filstørrelse: 300MB',
    uploadMsg3: 'Klik for at vælge eller træk & slip filer her.',
    uploading: 'Uploader',
    uploadingMsg: 'Uploader. Vent venligst.',
    uploadingMsg1: 'Fil上传中。 Prøv igen senere.',
    uploadingMsg2: 'En fil konverteres for tiden. Prøv venligst igen senere.',
    uploadingMsg3:
      'Anmodning om konverteringsstatus mislykkedes. Prøv igen senere eller kontakt support.',
    uploadingMsg4:
      'Noam kan ikke få adgang til lokale filer. Upload venligst manuelt en PDF til oversættelse.',
    uploadingMsg5: 'Kunne ikke hente fil-URL. Prøv venligst igen senere eller kontakt support.',
    video: 'video',
    vipBannerBtn: 'Opgradering',
    vipBannerTips: 'Du har nået din PDF-oversættelsesgrænse for denne måned.',
    webTrans: 'Fuld krydshenvisning',
  },
  pricing: {
    FAQ: 'Ofte stillede spørgsmål',
    FQAObj: {
      a1: 'Ja, Noam tilbyder en gratis plan, du kan bruge med det samme.',
      a2: 'Vi tilbyder tre medlemsplaner: Pro, Pro+ og Enterprise. Du kan vælge at betale månedligt eller årligt. Årlig fakturering giver betydelige besparelser.',
      a3: 'Alle funktioner er tilgængelige på begge abonnementplaner. Den største forskel er prisen: årlige abonnementer koster i alt mindre. Månedlige abonnementer faktureres hver måned, mens årlige planer faktureres én gang om året.',
      a4: 'Du kan afmelde dit abonnement når som helst i dine kontoindstillinger.',
      q1: 'Er der en gratis plan?',
      q2: 'Hvilke priserplaner og betalingsmuligheder er tilgængelige?',
      q3: 'Hvad er forskellen mellem at abonnere månedligt versus årligt?',
      q4: 'Hvordan afbestiller jeg min abonnement?',
    },
    around: 'Omkring',
    billedMonthly: 'Faktureres månedligt',
    billedYearly: 'Faktureret årligt',
    day: 'dag',
    desc: 'Sammenlign planer og vælg den bedste',
    detailedCompare: 'Sammenlign planer',
    discount: '20% rabat',
    enterprise: {
      benefit1: 'Prioriteret Kundestøtte',
      benefit2: 'Flere brugere',
      benefit3: 'Tilpassede Løsninger',
      benefit5: 'Dedicatede Kontoejer',
      btn: 'Kontakt os',
      recommendText: 'Tilpassede planer (≥3 personer)',
      talkToUs: 'Kontakt os',
    },
    free: {
      benefit1: 'Umiddelbar oversættelse 100 gange/dag',
      benefit2: 'Væbsitetranslation & Resumé',
      benefit3: '30 billedoversættelser',
      benefit4: 'Videooversættelse & Opsummering',
      benefit5: '10 PDF-øversættelser',
      benefit6: '5.000 tokens',
      btn: 'Prøv det gratis',
      recommendText: 'Gratis prøveperiode',
    },
    imageTranslation: 'Billedoversættelse',
    month: 'måned',
    monthly: 'Månedligt',
    pageTitle: 'Priser',
    pdf: {
      chat: 'PDF Chat-anmodninger',
      maxPage: 'Maks. sider per PDF',
      translation: 'PDF-oversættelse',
    },
    preMonth: 'Pr. måned',
    pro: {
      benefit1: 'Prioriteret Kundestøtte',
      benefit2: '1.000.000 tokens/måned',
      benefit3: 'Væbsitet oversættelse & opsummering',
      benefit4: '200 Billedoversættelser',
      benefit5: 'Videooversættelse & Resumé',
      benefit6: '200 PDF-oversættelser',
      btn: 'Start',
      recommendText: 'Mest Populært',
    },
    proPlus: {
      benefit1: 'Prioriteret kundesupport',
      benefit2: '3.000.000 tokens/måned',
      benefit3: 'Hjemmesideoversættelse & Opsummering',
      benefit4: '500 billedoversættelser',
      benefit5: 'Videotolkning & Opsummering',
      benefit6: '500 PDF-øversættelser',
      recommendText: 'Bedste Værdi',
    },
    video: { summary: 'Videoresumé', translation: 'Videotolkning' },
    web: {
      contrastiveTranslation: 'To sproget oversættelse',
      dictionaryTranslation: 'Vælg oversættelse',
      hoverTranslation: 'Hoveroversættelse',
      instantTranslation: 'Umiddelbar Oversættelse',
      summary: 'Websidesammendrag',
    },
    yearly: 'Årligt',
  },
  privacy: {
    block1:
      'Noam ("Noam," "vi," "vores" eller "os") respekterer din privatlivetsbeskyttelse og forpligter sig til at beskytte enhver information, vi opnår fra dig eller om dig. Denne privatlivspolitik beskriver vores praksis vedrørende indsamling eller brug af personlige oplysninger fra din brug af vores hjemmeside, apps og tjenester (sammenfattende kaldet "Tjenester"). Denne privatlivspolitik gælder ikke for indholdet, vi håndterer på vegne af vores forretningsproduktkunder, såsom vores API. Brug af disse data er underlagt vores kundeaftale, som dækker adgang til og brug af disse produkter.',
    block10:
      'Vi implementerer kommercielt rimelige tekniske, administrative og organisatoriske foranstaltninger til at beskytte online og offline personlige oplysninger mod tab, misbrug og uautoriseret adgang, afsløring, ændring eller hostile handlinger. Imidlertid kan ingen internet- eller e-mail-overførsel garantere fuldstændig sikkerhed eller nøjagtighed. Især e-mails sendt til os eller fra os er muligvis ikke sikre. Derfor bør du være særligt forsigtig, når du beslutter, hvilke oplysninger du sender til os gennem tjenesten eller e-mail. Desuden er vi ikke ansvarlige for nogen forstyrrelse af privatlivsinstillinger eller sikkerhedsforanstaltninger i tjenesten eller tredjeparts hjemmesiders sikkerhedsindstillinger eller sikkerhedsforanstaltninger. Vi opbevarer dine personlige oplysninger, så længe det er nødvendigt for at levere tjenester til dig eller for andre legitimate forretningsformål, såsom at løse tvister, sikkerheds- og sikkerhedsmæssige grunde eller overholde vores juridiske forpligtelser. Varigheden af, at vi opbevarer personlige oplysninger, afhænger af mange faktorer, såsom mængden, naturen, følsomheden af oplysningerne, de potentielle risici for uautoriseret brug eller afsløring, formålene med, at vi behandler oplysningerne, og andre juridisk bindende overvejelser.',
    block11:
      'Vi opdaterer muligvis denne privatlivspolitik fra tid til anden. Når vi gør det, vil vi indlægge en opdateret version på denne side, medmindre gældende lovgivning kræver andet.',
    block12:
      'Hvis du har nogen uløste spørgsmål eller bekymringer angående denne privatlivspolitik, bedes du kontakte vores kundeservice. E-mail:',
    block2:
      'Vi indsamler følgende personlige oplysninger ("Personlige oplysninger") relateret til dig:',
    block3:
      'Information angivet af dig: Når du opretter en konto til at bruge vores tjenester eller kommunikerer med os, indsamler vi personlige oplysninger som følger:',
    block4:
      'Personlige oplysninger, der automatisk modtages fra din brug af tjenester: Når du tilgår, bruger eller interagerer med tjenesterne, modtager vi følgende oplysninger om din adgang, brug eller interaktion ("Teknisk information"):',
    block5: 'Vi kan bruge personlige oplysninger til følgende formål:',
    block6:
      'Oversigt eller deidentificeret information: Vi kan aggregere eller deidentificere personlige oplysninger for at forhindre genbrug til identifikationsformål og bruge sådanne oplysninger til at analysere effektiviteten af vores tjenester, forbedre og tilføje funktioner til vores tjenester, foretage forskning og til lignende formål. Desuden kan vi analysere den generelle adfærd og egenskaber hos vores tjenesteanvendere og dele aggregeret information med tredjeparter, offentliggøre sådan aggregeret information eller gøre den generelt tilgængelig. Vi kan indsamle aggregeret information gennem tjenesterne, gennem cookies og gennem andre midler beskrevet i denne privatlivspolitik. Vi vil opretholde og bruge deidentificeret information i anonym eller deidentificeret form, og vi vil ikke forsøge at reidentificere sådanne oplysninger medmindre det kræves af lovgivningen.',
    block7:
      'I visse tilfælde kan vi levere dine personlige oplysninger til tredjeparter uden yderligere meddelelse til dig, medmindre loven kræver det:',
    block8:
      'Afhængigt af din geografiske placering kan personer i Den Europæiske Økonomiske Område, Storbritannien og globalt have visse lovbestemte rettigheder vedrørende deres personlige oplysninger. For eksempel har du muligvis ret til:',
    block9:
      'Tjenesten kan indeholde links til andre websites, der ikke drives eller kontrolleres af Noam, herunder sociale medier-tjenester ("Tredjepart-websites"). Den information, du deler med Tredjepart-websites, vil blive styret af de specifikke privatlivspolitikker og servicebetingelser for Tredjepart-websites, ikke af denne Privatlivspolitik. Vi tilbyder disse links for nemhedens skyld og antyder ikke vores godkendelse eller gennemgang af disse websites. Kontakt venligst Tredjepart-websites direkte for information om deres privatlivspolitikker og betingelser.',
    subBlock1:
      'Kontoinformation: Når du opretter en konto på vores platform, indsamler vi information relateret til din konto, herunder dit navn, kontaktoplysninger, kontooplysninger, betalingskortoplysninger og transaktionshistorik ("Kontoinformation").',
    subBlock10: 'Levering, styring, vedligeholdelse og/eller analyse af tjenester;',
    subBlock11: 'At kommunikere med dig;',
    subBlock12: 'Udvikling af nye produkter og tjenester;',
    subBlock13:
      'At forhindre svig, kriminel aktivitet eller misbrug af vores tjenester samt at beskytte sikkerheden af vores IT-systemer, arkitektur og netværk;',
    subBlock14: 'Udførelse af forretningsoverdragelser;',
    subBlock15:
      'At overholde juridiske forpligtelser og retlige forløb, beskytte vores rettigheder, privatliv, sikkerhed eller ejendom, samt those tilhørende vores tilknyttede selskaber, dig eller andre tredjeparter.',
    subBlock16:
      'Leverandører og serviceudbydere: For at hjælpe os med at opfylde forretningsmæssige driftsbehov og udføre visse tjenester og funktioner, kan vi levere personlige oplysninger til leverandører og serviceudbydere, herunder hosting-serviceudbydere, cloud-serviceudbydere, andre informationsteknologiske serviceudbydere, e-mail-kommunikationssoftware og webanalyse-serviceudbydere osv. Disse partnere vil kun få adgang til, behandle eller opbevare personlige oplysninger efter vores anvisning, når de udfører deres opgaver for os.',
    subBlock17:
      'Forretningsoverførsler: Hvis vi indgår i strategiske transaktioner, reorganiseringer, konkurser, konkursoptagelser eller overfører tjenester til en anden leverandør (sammensat kaldet "Transaktioner"), kan dine personlige oplysninger og andre oplysninger deles med transaktionsmodparter og andre parter, der assisterer i Transaktionerne under due diligence, og overføres som en del af Transaktionerne sammen med andre aktiver til et efterfølger- eller tilknyttet selskab.',
    subBlock18:
      'Lovlige krav: Vi kan dele dine personlige oplysninger med myndigheder, branchekolleger eller andre tredjeparter, herunder dine interaktionsoplysninger med vores tjenester, (1) hvis det er krævet af loven eller hvis vi mener, at en sådan handling er nødvendig for at overholde lovpligter; (2) for at beskytte og forsvare vores rettigheder eller ejendom; (3) hvis vi ensidigt fastlægger, at der er et overtrædelse af vores vilkår, politikker eller love; (4) for at opdage eller forhindre svig eller andre ulovlige aktiviteter; (5) for at beskytte vores produkter, medarbejdere eller brugere, eller offentlig sikkerhed, sikkerhed, integritet; eller (6) for at forsvare os mod juridisk ansvar.',
    subBlock19: 'Adgang til dine personlige oplysninger og oplysninger om, hvordan de behandles.',
    subBlock2:
      'Når du bruger vores tjenester, indsamler vi personlige oplysninger fra dine input, filupload eller feedback, du har givet os ("Indhold").',
    subBlock20: 'Anmod om sletning af dine personlige oplysninger fra vores poster.',
    subBlock21: 'Korriger eller opdater dine personlige oplysninger.',
    subBlock22: 'Overfør din personlige information til en tredjepart (dataportabilitet).',
    subBlock23: 'Begræns hvordan vi behandler dine personlige oplysninger.',
    subBlock24:
      'Træk dit samtykke tilbage — når vi stoler på samtykke som det juridiske grundlag for behandling, kan du trække dit samtykke tilbage til enhver tid.',
    subBlock25: 'Protester mod hvordan vi behandler dine personlige oplysninger.',
    subBlock26: 'Forbedring af vores tjenester og gennemførelse af forskning;',
    subBlock3:
      'Kommunikationsoplysninger: Hvis du sender os beskeder, vil vi indsamle dit navn, kontaktoplysninger og indholdet af dine beskeder ("Kommunikationsoplysninger").',
    subBlock4:
      'Information om sociale medier: Vi har sider på sociale medieplatforme såsom Instagram, Facebook, Medium, Twitter, YouTube og LinkedIn. Når du interagerer med vores sociale mediesider, indsamler vi den personlige information, du vælger at give os, f.eks. dine kontaktoplysninger ("Sociale oplysninger"). Desuden kan de virksomheder, der hoster vores sociale mediesider, levere os aggregeret information og analyse om vores sociale medieaktiviteter.',
    subBlock5:
      'Logdata: Information, der automatisk sendes af din browser, når du bruger vores tjenester. Logdata inkluderer din Internet Protocol (IP)-adresse, browsertype og indstillinger, dato og tid for dine anmodninger samt hvordan du interagerer med vores hjemmeside.',
    subBlock6:
      'Brugsdata: Vi kan automatisk indsamle oplysninger om din brug af tjenesten, såsom typerne af indhold, du ser eller interagerer med, de funktioner, du bruger, de handlinger, du udfører, samt din tidszone, land, adgangsdato og -tid, brugeragent og version, type computer eller mobil enhed samt din computerforbindelse.',
    subBlock7:
      'Enhedsinformation: Dette omfatter enhedens navn, operativsystem, enhedsidentifikator og den browser, du bruger. Den indsamlede information kan afhænge af den type enhed, du bruger, og dens indstillinger.',
    subBlock8:
      'Cookies: Vi bruger cookies til at drive og administrere vores tjenester samt forbedre din oplevelse. En "cookie" er information, der sendes fra en hjemmeside, du besøger, til din browser. Du kan indstille din browser til at acceptere alle cookies, afvise alle cookies eller underrette dig, når en cookie leveres, så du kan bestemme, om du vil acceptere den hver gang. At afvise cookies kan dog forhindre dig i at bruge eller påvirke visningen eller funktionaliteten af visse områder eller funktioner på hjemmesiden negativt. For mere information om cookies, besøg venligst All About Cookies.',
    subBlock9:
      'Analytik: Vi kan bruge forskellige online-analytikprodukter, der bruger cookies til at hjælpe os med at analysere, hvordan brugere bruger vores tjenester, og forbedre din oplevelse, når du bruger tjenesterne.',
    subTitle1: 'Den personlige information, vi indsamler',
    subTitle2: 'Hvordan vi bruger personlige oplysninger',
    subTitle3: 'Offentliggørelse af personlige oplysninger',
    subTitle4: 'Dine rettigheder',
    subTitle5: 'Links til andre websites',
    subTitle6: 'Sikkerhed og bevarelse af oplysninger',
    subTitle7: 'Ændring af privatlivspolitik',
    subTitle8: 'Sådan kontakter du os',
    title: 'Persondatapolitik',
    updateTime: 'Opdateret: 15. marts 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Accepter alle',
    text: 'For at forbedre din oplevelse bruger vi cookies til at personalisere indhold og tjenester.',
    title: 'Denne hjemmeside bruger cookies',
  },
  slogen: 'Den nemmeste AI-assistent',
  stripe: {
    contact: 'Kontakt os på contact@noam.tools med eventuelle spørgsmål!',
    fail: {
      btn: 'Genoptryk',
      text1: 'Vi kunne ikke behandle din betaling.',
      text2: 'Tjek din forbindelse og prøv igen.',
      title: 'Betaling mislykkedes',
    },
    succ: {
      btn: 'Lad os gå',
      text1: 'Velkommen til Noam',
      text2: 'lad os komme i gang!',
      title: 'Tillykke',
    },
  },
  terms: {
    block1: 'Tak for at bruge Noam!',
    block10:
      'Gebyrer og fakturering. Du betaler alle gebyrer ("Gebyrer") i henhold til priserne og vilkårene på den anvendelige pris side eller som aftalt i skriftlig form mellem os. Vi forbeholder os ret til at rette prisfejl eller fejl, selv hvis vi har udstedt fakturaer eller modtaget betaling. Du skal levere komplet og korrekt faktureringsoplysninger, herunder en gyldig og autoriseret betalingsmetode. Vi debiterer din betalingsmetode med jævne mellemrum som aftalt, men vi kan fornuftigt ændre faktureringsdatoen. Du autoriserer Noam, dets tilknyttede virksomheder og tredjeparts betalingsprocessorer til at debitere din betalingsmetode. Hvis din betaling mislykkes, sender vi dig skriftlig meddelelse og kan suspendere adgangen til tjenesten, indtil betalingen er modtaget. Medmindre andet er angivet i denne aftale, er betalinger ikke refundérbare.',
    block11:
      '(b) Skatter. Medmindre andet er angivet, inkluderer gebyrerne ikke nogen føderale, statlige, lokale eller udenlandske skatter, afgifter eller lignende opkrævninger ("Skatter"). Du er ansvarlig for alle skatter, der er forbundet med dine køb, undtagen skatter baseret på vores nettoindtægt, som vi vil fakturere dig for. Du accepterer at betale disse skatter hurtigt samt at levere os lovligt gyldige privatlivserklæringer og indhente nødvendige samtykker til behandling af sådan data, og du garanterer for os, at du behandler sådant data i overensstemmelse med gældende lovgivning.',
    block12:
      '(c) Prisændringer. Vi forbeholder os ret til at ændre vores priser ved at give dig besked gennem din konto og/eller vores hjemmeside. Prisstigninger træder i kraft med det samme efter offentliggørelse. Alle prisændringer vil gælde for gebyrer på din konto efter ændringens ikrafttrædelsesdato.',
    block13:
      '(d) Tvister og forfaldne betalinger. Hvis du ønsker at bestride nogen gebyrer eller skatter, bedes du kontakte contact@noam.tools inden for tredive (30) dage fra fakturadatoen.',
    block14:
      '(e) Fri brug. Du må ikke oprette flere konti for at få fri kredit. Hvis vi fastslår, at du ikke bruger de frie kreditter i god tro, kan vi opkræve standardgebyrer eller stoppe adgangen til tjenesten.',
    block15:
      'Konfidentialitet. Du har muligvis adgang til konfidentiel information fra Noam. Du må kun bruge konfidentiel information i overensstemmelse med disse vilkår til formålet med at bruge tjenesten. Du må ikke afsløre konfidentiel information til tredjeparter, og du skal beskytte konfidentiel information på en måde, der er mindst lige så beskyttende som den måde, du beskytter din egen lignende konfidentielle information, i det mindste med rimelig omhu. Konfidentiel information er ikke-offentlig information, der er angivet som konfidentiel af Noam eller som rimeligt bør behandles som konfidentiel under de givne omstændigheder, herunder software, specifikationer og anden ikke-offentlig forretningsinformation. Konfidentiel information omfatter ikke information, der: (1) bliver almindeligt tilgængelig for offentligheden uden at du er tilskyldig; (2) du havde i din besiddelse uden nogen forpligtelse til konfidentialitet, før du modtog den under disse vilkår; (3) er lovligt afsløret til dig af en tredjepart uden nogen konfidentialitetsforpligtelser; eller (4) er uafhængigt udviklet af dig uden at bruge den konfidentielle information. Du må afsløre konfidentiel information, hvis det kræves af lov, ret eller anden statsorden, men du skal give Noam forudgående skriftlig meddelelse på en rimelig måde, og i den grad det er muligt, gøre rimelige bestræbelser for at begrænse omfanget af afsløringen, herunder at hjælpe os med at modvirke anmodninger om afsløring.',
    block16:
      '(b) Sikkerhed. Du skal implementere rimelige og passende foranstaltninger for at hjælpe med at beskytte din adgang til og brug af tjenesten. Hvis du opdager eventuelle sårbarheder eller overtrædelser i forbindelse med din brug af tjenesten, skal du straks kontakte Noam og levere oplysninger om sårbarheden eller overtrædelsen.',
    block17:
      '((c) Behandling af personlige data. Hvis du bruger tjenesten til at behandle personlige data, skal du levere juridisk tilstrækkelige privatlivserklæringer og indhente nødvendige samtykker til behandling af sådanne data, og du garanterer os, at du behandler sådanne data i overensstemmelse med gældende lovgivning.',
    block18:
      '(a) Ophævelse; Suspendering. Disse vilkår træder i kraft fra din første brug af tjenesten og forbliver gyldige indtil de ophæves. Du kan ophæve disse vilkår til enhver tid og af enhver grund ved at stoppe med at bruge tjenesten og indholdet. Vi kan ophæve disse vilkår med forudgående varsel af enhver grund. Vi kan umiddelbart ophæve disse vilkår ved at give dig besked, hvis du brækker afgørende afsnit 2 (Brugskrav), afsnit 5 (Fortrolighed, sikkerhed og databeskyttelse), afsnit 8 (Tvistløsning) eller afsnit 9 (Almindelige vilkår), eller hvis vores forhold til en tredjepartsteknologileverandør uden for vores kontrol ændres, eller for at overholde lovgivning eller myndighedsbekræftelser. Vi kan suspendere din adgang til tjenesten, hvis du ikke overholder disse vilkår, eller hvis din brug udgør et sikkerhedsrisiko for os eller en tredjepart, eller hvis vi mistænker, at din brug er svigagtig eller kan udsætte os eller en tredjepart for ansvar.',
    block19:
      '(b) Konsekvenser af ophævelse. Ved ophævelse skal du ophøre med at bruge tjenesten og straks returnere eller ødelægge enhver fortrolig information efter vores anvisning. Disse vilkårss bestemmelser, der ved deres natur bør overleve ophævelse eller udløb, herunder men ikke begrænset til afsnit 3 og 5-9, forbliver gjældende.',
    block2:
      'Disse brugsbetingelser gælder for din brug af Noams tjenester, herunder vores applikationsprogrammeringsgrænseflader, software, værktøjer, udviklertjenester, data, dokumentation og hjemmeside (sammensat henvist til som "Tjenester"). Ved at bruge vores Tjenester accepterer du at overholde disse vilkår. Vores privatlivspolitik forklarer, hvordan vi indsamler og bruger personlige oplysninger.',
    block20:
      '(a) Erstatningsansvar. Du skal forsvare, erstatte og holde os, vores tilknyttede selskaber og vores medarbejdere uskyldige mod enhver krav, tab og udgifter (herunder advokatomkostninger) som opstår fra eller er relateret til din brug af tjenesten, herunder dit indhold, din brug af produkter eller tjenester relateret til tjenesten samt din overtrædelse af disse vilkår eller gældende lovgivning.',
    block21:
      '(b) Ansvarsbegrænsninger. Tjenesten leveres "som den er". I den grad loven tillader det, giver vi og vores tilknyttede virksomheder samt licensgivere ingen erklæringer eller garantier af nogen art vedrørende Tjenesten, og vi giver ingen garantier, herunder men ikke begrænset til garantier for handelsgyldighed, egnethed til et bestemt formål, tilfredsstillende kvalitet, ikke-overtrædelse og uforstyrret ejerskab, samt eventuelle garantier, der opstår ud af forretningsforbindelser eller erhvervsmæssig brug. Vi garanterer ikke, at Tjenesten vil være uafbrudt, nøjagtig eller fejlfri, eller at indhold vil være sikkert, ikke gå tabt eller ikke blive ændret.',
    block22:
      '(c) Begrænsning af ansvar. Verken vi, vores tilknyttede selskaber eller vores licensgivere er ansvarlige for indirekte, tilfældige, særlige, følgeskade eller strafskadeer, herunder tab af fortjenester, tab af ry, tab af brug, tab af data eller andre immaterielle tab, selv hvis vi har været underrettet om muligheden for sådanne skader. I henhold til disse vilkår overstiger vores samlede ansvar ikke de gebyrer, du har betalt for tjenesten i de tolv (12) måneder før kravet, eller 100 amerikanske dollars (100 USD), efter hvilken der er størst. Begrænsningerne i dette afsnit gælder i den maksimale udstrækning, der tillades af gældende lovgivning.',
    block23:
      'Betingelserne og din brug af tjenesterne er reguleret af de amerikanske love, undtagen for amerikanske love om lovkonflikter. Din brug af applikationen kan desuden være underlagt andre lokale, statslige, nationale eller internationale love. Enhver retlig handling eller procedure relateret til disse betingelser bringes udelukkende før amerikanske domstole, og du accepterer at underkaste dig den personlige jurisdiktion af disse domstole.',
    block24:
      'Forhold mellem parterne. Noam og du er uafhængige entreprenører, og ingen af parterne har beføjelse til at repræsentere eller binde den anden part eller påtage sig forpligtelser for den anden part uden den andens forudgående skriftlige samtykke.',
    block25:
      '(b) Brug af mærke. Du må ikke bruge navnet, logoerne eller varemærkerne for Noam eller enhver af dets tilknyttede selskaber uden vores forudgående skriftlige samtykke.',
    block26:
      'Hvis en bestemmelse i disse vilkår fastslås at være ugyldig, ulovlig eller ikke gennemførbar, forbliver de øvrige bestemmelser fuldt gyldige og bindende.',
    block3:
      'Hvis du er under 18 år gammel, skal du hente tilladelse fra dine forældre eller juridiske værger for at bruge tjenesten. Hvis du bruger tjenesten på vegne af en anden person eller enhed, skal du være bemyndiget til at acceptere disse vilkår på deres vegne. Du skal angive nøjagtig og komplet information for at registrere en konto. Du må ikke give dine adgangsoplysninger eller konto til nogen uden for din organisation, og du er ansvarlig for alle aktiviteter, der udføres ved hjælp af dine oplysninger.',
    block4:
      '(a) Brug af service. Du har adgang til tjenesten under disse vilkår, og vi giver dig en ikke-eksklusiv ret til at bruge tjenesten. Når du bruger tjenesten, skal du overholde disse vilkår og alle gældende love. Vi og vores tilknyttede virksomheder ejer alle rettigheder, titler og interesser i tjenesten.',
    block5:
      '(b) Feedback. Vi ønsker feedback, kommentarer, ideer, forslag og forbedringer velkommen. Hvis du leverer sådan indhold, må vi bruge det uden nogen restriktioner og uden kompensation til dig.',
    block6:
      "(c) Restriktioner. Du må ikke: (1) bruge tjenesten på en måde, der krænker, misapproprierer eller overtræder andres rettigheder; (2) reverse engineer, dekompilere, demontere, oversætte eller på anden måde forsøge at afdække kildekoden eller underliggende komponenter af tjenestens modeller, algoritmer og systemer (medmindre sådanne restriktioner er forbudt af gældende lov); (3) bruge outputtet fra tjenesten til at udvikle modeller, der konkurrerer med Noam; (4) udtrække data eller output fra tjenesten ved hjælp af automatiske eller programmeringsmetoder, medmindre det er tilladt gennem API'en, herunder scraping, web-harvesting eller web-dataudtrækning; (5) præsenterer outputtet fra tjenesten som kunstigt genereret, når det ikke er det, eller på anden måde overtræde vores brugsregler; (6) købe, sælge eller overføre API-nøgler uden vores forudgående samtykke; eller (7) levere os personlige oplysninger om børn under 13 år eller den anvendelige alder for digital samtykke. Du vil overholde eventuelle ratebegrænsninger og andre krav i vores dokumentation.",
    block7:
      '(d) Tredjepartsydelser. Enhver tredjepartsoftware, tjenester eller andre produkter forbundet med Tjenesten er reglementeret af deres egne vilkår, og vi er ikke ansvarlige for tredjepartsprodukter.',
    block8:
      '(a) Din indhold. Du kan levere input ("Input") til tjenesten og modtage output ("Output") genereret og returneret baseret på inputtet (sammensat henvist til som "Indhold"). mellem parterne, og i den grad lov tillader, ejer du al Input. Noam må bruge Indhold til at levere og vedligeholde tjenesten, overholde gældende love og håndhæve vores politikker. Du er ansvarlig for Indholdet, herunder at sikre, at det ikke krænker nogen gældende love eller disse vilkår.',
    block9:
      '(b) Nøjagtighed. Kunstig intelligens og maskinlærning er hurtigt udviklende forskningsområder. Vi stræber konstant efter at forbedre vores service for at gøre den mere nøjagtig, pålidelig, sikker og gavnlig. På grund af maskinlærningens sandsynlighedsnatur kan brug af vores service i visse tilfælde resultere i forkert output, som måske ikke præcist afspejler reelle personer, steder eller fakta. Du bør vurdere nøjagtigheden af ethvert output passende ud fra dit anvendelsesområde, herunder ved manuelt at gennemse outputtet.',
    subTitle1: 'Registrering og adgang',
    subTitle10: 'Skillevænlighed',
    subTitle2: 'Brugsanvisninger',
    subTitle3: 'Indhold',
    subTitle4: 'Gebyrer og betaling',
    subTitle5: 'Konfidentialitet, Sikkerhed og Databeskyttelse',
    subTitle6: 'Løbetid og Ophør',
    subTitle7: 'Erstatning; Afvisninger; Begrænsning af ansvar',
    subTitle8: 'Bestemmende lovgivning og jurisdiktion',
    subTitle9: 'Generelle vilkår',
    title: 'Servicevilkår',
    updateTime: 'Opdateret: 15. marts 2024',
  },
  trialModal: {
    btn: 'Start nu (kun $0,99)',
    chat: 'ChatPDF',
    desc1: 'Efter din prøveperiode vil du blive opkrævet en årlig gebyr på $180',
    desc2: 'Annullér når som helst',
    focus: 'Fokusering',
    hover: 'Svævende oversættelse',
    image: 'Billedoversættelse',
    installBtn: 'Installér nu for at modtage din gave',
    memo: 'Håndtering af favoritter',
    pdf: 'PDF-parallelt oversættelse',
    realtime: 'Umiddelbar oversættelse',
    select: 'Ordvalgsoversættelse',
    title: 'Velkomstgave',
    trialText: '7-dages prøveperiode',
    video: 'Videotolkning',
    videoSummary: 'Videoresumé',
    web: 'Parallell oversættelse',
    webSummary: 'Webopsummering',
  },
  upgradeModal: {
    btn: 'Opgrader nu',
    chat: {
      free: 'Du har nået ChatPDF-grænsen',
      pro: 'Du har nået ChatPDF-grænsen for denne måned',
    },
    contactStr: 'Vent venligst på næste nulstilling, eller kontakt os på contact@noam.tools.',
    limitAlertStr: 'Du har nået grænsen for din gratis plan. Opgrader for at fortsætte.',
    more: 'Se planer',
    pageLimit: { free: 'Du har nået PDF-sidetællingsgrænsen' },
    title: 'Påmindelse',
    upgradeAlertStr: 'Du har nået grænsen for din gratis plan. Opgrader for at fortsætte.',
    upload: {
      free: 'Du har nået din PDF-oversættelsesgrænse',
      pro: 'Du har nået din PDF-oversættelsesgrænse for denne måned',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Tilmeld dig nu',
      label: 'Ny brugerfordele:',
      remain: 'Kun 30 tilbage',
      text: 'Kun 100 pladser tilgængelige! Tag din nu!',
    },
  },
  aiPdfTranslator: {
    title: 'Gratis AI PDF-oversætter: Oversæt PDF med sammenligning på alle sprog',
    desc: 'Oversæt PDF-filer nemt til alle sprog med AI. Sammenlign original- og oversat tekst side om side, hurtigt og gratis.',
    keywords: 'GPT-4、AI-assistent、Oversættelse、Opsummering、Fokus、ChatPDF、Notat、effektivitet',
    sourceToTarget: {
      title: 'Gratis PDF- oversættelsesværktøj: oversæt {{source}} til {{target}} gratis',
      desc: 'Oversæt dine PDF-filer fra ethvert kildesprog til dit foretrukne sprog gratis. Hurtig, nøjagtig og sikker PDF-oversættelse drevet af avanceret AI.',
    },
    headerIntroduce: {
      title: 'Noam: Mere end blot onlineoversættelse',
      introduce1: {
        title: 'Noam · PDF-læser',
        desc: "✨Side-by-side oversættelse + AI-spørgsmål og svar. Oversæt hurtigt og nøjagtigt PDF'er til dit målsprog. Stil frit spørgsmål om indholdet for at få en dybere forståelse af dine PDF-filer.",
      },
      introduce2: {
        title: 'Noam · Side-by-side Oversættelsesudvidelse',
        desc: '👏Løs alle dine hjemmesideoversættelsesbehov:',
        detail1: { title: 'Vebsideoversættelse:', desc: 'Side ved side tosprogigt view' },
        detail2: { title: 'Ordoversættelse:', desc: 'Klikkefast oversættelse' },
        detail3: {
          title: 'Umiddelbar oversættelse:',
          desc: 'Oversæt ord eller sætninger øjeblikkeligt.',
        },
        detail4: { title: 'Billedoversættelse:', desc: 'Erstat billeder med oversatte.' },
        detail5: {
          title: 'Videooversættelse:',
          desc: 'To sprogede undertekster til bedre seeropplevelse.',
        },
        footer: 'Oplev flere AI-drevne læsefunktioner til mere intelligente oversættelser!',
      },
    },
    subtitle: 'Oversæt PDF online gratis',
    introduce: {
      module1: {
        detail1: {
          title: 'Realtids side-i-side PDF-oversættelse',
          desc1:
            'Vis originalt og oversat indhold øjeblikkeligt i et synkroniseret layout side om side',
          desc2: 'Sammenlign begge versioner uden anstrengning med synkroniseret scrolling',
          desc3: 'Bevar identisk formatering for en konsistent læseoplevelse',
        },
        detail2: {
          title: 'Præcis Indholdstilpasning og Verifikation',
          desc1: 'Perfekt alignment mellem kilde- og oversat tekst for nem verificering',
          desc2: 'Hvert indholdsegment matcher nøjagtigt mellem begge versioner',
          desc3: 'Rapidt identificer og løs op på oversættelsesforskelle for pålidelige resultater',
        },
      },
      module2: {
        detail1: {
          title: 'Adskilte Avancerede AI-modeller til Præcis Oversættelse',
          desc1: 'Vælg blandt førende AI-modeller for at opfylde dine oversættelsesbehov',
          desc2: 'Sikre optimale resultater for forskellige dokumenttyper og brancher',
          desc3: 'Fleksible modelmuligheder giver skræddersyede løsninger til enhver situation',
        },
        detail2: {
          title: 'Avanceret AI-oversættelse til alle indholdstyper',
          desc1:
            'Vores kraftfulde AI-model sikrer høj nøjagtighed og forståelse af naturligt sprog',
          desc2: 'Håndterer tekniske, akademiske og kreative dokumenter med nemhed',
          desc3: 'Leiver pålidelige resultater til alle dine oversættelsesbehov',
          desc4: 'Intelligent tilpasning til forskellige indholdstyper for optimal ydeevne',
        },
      },
      module3: {
        detail1: {
          title: 'Intelligent Dokumentinteraktion',
          desc1:
            'Chat uden anstrengelse med dine PDF- og præsentationsfiler ved hjælp af avanceret AI',
          desc2: 'Stil spørgsmål om dokumentindhold med det samme og få nøjagtige svar',
          desc3: 'Generer hurtigt korte opsummeringer af lange dokumenter',
        },
        detail2: {
          title: 'Dyb indholdanalyse og naadlos integration',
          desc1: 'Udtræk nøgleinformation og analysér komplekse data med AI-styret forståelse',
          desc2: 'Få indsigt i tekniske, akademiske eller kreative materialer',
          desc3:
            'Integrerer problemfrit med vores PDF- oversætter for en komplet dokumenthåndteringsløsning',
        },
      },
      module4: {
        detail1: {
          title: 'Ud over PDF-oversættelse: All-i-én løsning til hjemmesideoversættelse',
          desc: 'Udforsk vores kraftfulde side-i-side oversættelsesudvidelse, der er designet til enhver online læsescenarie.',
          desc1:
            'Vebsideoversættelse: Nyd tosprogindhold med en synkroniseret side-ved-side-visning',
          desc2: 'Ordoversættelse: Oversæt markerede ord med ét enkelt klik',
          desc3:
            'Umiddelbar oversættelse: Oversæt enhver tekst eller sætning på stedet for hurtig forståelse',
          desc4: 'Billedoversættelse: Erstat automatisk originale billeder med oversatte versioner',
          desc5:
            'Videotranslation: Se videoer med tosprogige undertekster for en forbedret oplevelse',
        },
      },
    },
    question: {
      title: 'Ofte stillede spørgsmål',
      answer1: {
        title: 'Er Noam PDF Translator gratis at bruge til PDF-oversættelse?',
        content:
          "Ja, du kan oversætte PDF'er gratis med Sider PDF Translator! Vi tilbyder en gratis kvote på 5.000 tokens, hvilket er tilstrækkeligt til at oversætte de fleste PDF-dokumenter, der almindeligvis findes på markedet. Hvis du har brug for at oversætte større filer eller har brug for avancerede funktioner, kan du vælge at opgradere til vores premiumplaner for endnu flere muligheder.",
      },
      answer2: {
        title: 'Hvor nøjagtig er Noam PDF Translator?',
        content:
          'Noam PDF Translator leverer meget nøjagtige oversættelser ved at bruge avanceret AI-teknologi og dybdegående forståelse af konteksten i dine dokumenter. Selvom ingen automatisk oversættelse er fejlfri, giver vores side-til-side-visning dig mulighed for nemt at gennemgå og forfinede hver oversættelse, hvilket sikrer, at det endelige resultat opfylder dine kvalitetsforventninger. Oplev pålidelig og præcis PDF-oversættelse med Noam.',
      },
      answer3: {
        title: "Kan jeg oversætte scannede PDF'er?",
        content:
          "Ja, du kan oversætte scannede PDF'er med vores indbyggede OCR-teknologi (Optisk Tegnsgenkendelse). Vores system udtrækker automatisk tekst fra scannede dokumenter og billedbaserede PDF'er og oversætter derefter indholdet for dig. Dette sikrer, at selv ikke-redigérbare eller kun-billede-PDF'er kan oversættes nøjagtigt.",
      },
      answer4: {
        title: 'Hvor lang tid tager oversættelsen?',
        content:
          'Oversættelse er hurtig og effektiv – de fleste dokumenter behandles på få sekunder til et par minutter, afhængigt af deres længde og kompleksitet. Et standard 10-sidet PDF tager for eksempel normalt mindre end 2 minutter at oversætte. Nyd hurtige afleveringstider til alle dine dokumentoversættelsesbehov!',
      },
      answer5: {
        title: 'Kan jeg beholde side-for-side-visningen til læsning?',
        content:
          'Ja, du kan altid læse dine dokumenter side om side. Denne layoutmulighed giver dig mulighed for nemt at sammenligne det originale indhold og det oversatte indhold, hvilket sikrer en jævn og effektiv læseoplevelse.',
      },
    },
    freeTrial: 'Gratis prøveperiode',
    toLanguage: { title: 'PDF AI Oversættelsespar', item: '{{source}} til {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blog',
      features: 'Funktioner',
      button: 'Oversæt nu',
      faq: 'Ofte stillede spørgsmål',
      pricing: 'Priser',
    },
    hero: {
      upload: {
        title: 'Upload din PDF',
        max: 'Max',
        highlight: 'Klik for at bla',
        desc: 'eller træk og slip',
      },
      to: 'til',
      pill: 'AI-drevet PDF-oversetter',
      title: 'Gratis PDF-oversætter',
      model: 'GPT-4 & Claude',
      desc: 'Umiddelbare, nøjagtige oversættelser, der bevarer det originale layout. Noam AI understøtter OCR og side-til-side-visninger.',
      free: 'Gratis prøveperiode',
      support: 'OCR-understøttelse',
      translated: 'Oversat af Noam',
      complete: 'Oversættelse fuldført',
    },
    ticker: {
      pdf: 'PDF-oversættelse',
      format: 'Formatholdelse',
      multi: 'Flersproget',
      ocr: 'OCR-teknologi',
      side: 'Side om side',
      chat: 'Chat med PDF',
      web: 'Weboversættelse',
      secure: 'Sikker & Privat',
    },
    comparison: {
      bad: {
        title: 'Standard oversættelse',
        head: 'Tabt formatering & kontekst',
        text1: 'Fejl: Layout ødelagt. Billeder placeret forkert.',
        text2:
          'Teksten overlapper, og skrifttyperne er inkonsistente. Svært at læse og uprofessionelt...',
      },
      dump: { title: 'Almindelig tekstudtræk' },
      good: {
        title: 'Noam AI Oversættelse',
        tag: 'Perfekt resultat',
        sub: 'Perfekt Formatering, Kontekstbevidst',
      },
      title: 'Hvorfor vælge Noam AI?',
      desc: 'Stop med at kæmpe med kopi-indsæt-øversættelse. Oplev forskellen mellem standardværktøjer og vores AI-styret kontekstavare øversættelse.',
    },
    showcase: {
      title1: 'Ethvert Dokument',
      kicker: 'UNDERSTØTTETE DOKUMENTER',
      title2: 'Ethvert sprog',
      carousel1: 'Kunst',
      carousel2: 'Arkitektur',
      carousel4: 'Medicin',
      note: 'Håndter tekniske, akademiske og kreative dokumenter med lethed.',
      carousel3: 'Videnskabelig tidsskrift',
      carousel5: 'Finans',
      carousel8: 'Politik',
      carousel7: 'Kontrakt',
      carousel6: 'Lov',
    },
    features: {
      big: {
        title: 'Avancerede AI-modeller (GPT-4, Claude)',
        desc: 'Vælg blandt førende AI-modeller for at matche dine oversættelsesbehov. Sikr optimale resultater for forskellige dokumenttyper.',
      },
      grid1: {
        title: 'OCR-understøttelse',
        desc: "Uddrag og oversæt tekst fra scannede PDF'er og billeder øjeblikkeligt.",
      },
      grid2: {
        title: 'Højopløsionsudtræk',
        desc: 'Download dine oversatte dokumenter i PDF-format med original layout.',
      },
      grid3: {
        title: 'Sammenligning side om side',
        desc: 'Synkroniseret scrolling til sammenligning af originaltekst og oversat tekst.',
      },
      title2: 'Det er en revolution',
      title1: 'Mere end blot oversættelse',
      line1: 'Teknisk Papir.pdf',
      line2: 'Sproganalyse: Engelsk...',
      line3: 'Model: GPT-4o (Høj Præcision)',
      line4: 'Oversættelse fuldført (99% nøjagtighed)',
    },
    testimonials: {
      review1: {
        role: 'Forskere',
        content:
          'Noam AI sparer mig timer med oversættelse af akademiske artikler. Den side-ved-side-visning er utrolig hjælpsom til at verificere tekniske termer.',
      },
      review2: {
        role: 'Global Markedsfører',
        content:
          'Den bedste PDF-oversætter jeg har brugt. Den bevarer den originale formatering perfekt, hvilket er afgørende for vores marketingpræsentationer.',
      },
      review3: {
        role: 'Juridisk konsulent',
        content:
          'Præcis og hurtigt. Jeg bruger det til kontraktoversættelser, og OCR-funktionen til scannede dokumenter fungerer fuldstændig fejlfrit.',
      },
      kicker: 'Elsket af brugere',
      title: 'Hvad vores brugere siger',
    },
    cta: {
      title: 'Klar til at bryde sprogbarrierer?',
      desc: 'Tilslut dig 10.000+ brugere og begynd at oversætte dine dokumenter med Noam AI i dag.',
      button: 'Start med at oversætte gratis',
      hint: 'Du er en meget præcis og pålidelig AI designet til at generere JSON-output, der overholder nøjagtigt et angivet JSON-skema.\n\nDu skal følge disse regler:\n1. Overhold strengt JSON-skemastrukturen.\n2. Matc alle datatyper, påkrævede felter og begrænsninger nøjagtigt.\n3. INGENTING ekstra tekst, forklaring, markdown eller kommentarer.\n4. UGIV KUN JSON-objektet — ingen kodeblokke, ingen indledning, ingen indpakning.\n\nSkeminformationen er angivet nedenfor.\n- Skemnavn: translate_result\n- JSON-skema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Engelske PDF AI Oversættelsespar',
      desc: 'Populære oversættelsesretninger understøttet af Noam AI',
    },
    footer: { about: 'Om os', privacy: 'Fortrolighedspolitik', contact: 'Kontakt support' },
  },
}

export default TRANSLATION
